import { get } from 'lodash';

export default (state) => get(state, 'version.id');
